import { useEffect, useState } from "react";
import Select from "../../../Select/Select";
import Ripple from "../../../ui/spinners/ripple/Ripple";
import {
  getAllCarBrandsInInventoryForSalesWebsite,
  getAllCarModelsInInventoryGivenCarBrandId,
  getAllCarsInInventoryGivenCarModelId,
} from "../../../../services/car";

const CarSelection = ({ selectedCar, setSelectedCar }) => {
  const [brandsLoading, setBrandsLoading] = useState(false);
  const [brandsList, setBrandsList] = useState([]);
  const [modelsLoading, setModelsLoading] = useState(false);
  const [modelsList, setModelsList] = useState([]);
  const [yearsLoading, setYearssLoading] = useState(false);
  const [yearsList, setYearsList] = useState([]);

  // handlers
  const carBrandSelectedHandler = (option) => {
    setSelectedCar((prevState) => ({
      ...prevState,
      brand: option,
      model: null,
      year: null,
      carDetails: null,
    }));
  };

  const carModelSelectedHandler = (option) => {
    setSelectedCar((prevState) => ({
      ...prevState,
      model: option,
      year: null,
      carDetails: null,
    }));
  };

  const carYearSelectedHandler = (option) => {
    setSelectedCar((prevState) => ({
      ...prevState,
      year: option,
      carDetails: null,
    }));
  };
  const carDetailsSelectedHandler = (option) => {
    setSelectedCar((prevState) => ({
      ...prevState,
      carDetails: option,
    }));
  };

  const getCarDetails = () => {
    if (selectedCar?.year) {
      return { disabled: false, options: [selectedCar.year] };
    } else {
      return { disabled: true, options: [] };
    }
  };

  useEffect(() => {
    const getBrands = async () => {
      setBrandsLoading(true);
      try {
        const response = await getAllCarBrandsInInventoryForSalesWebsite();
        setBrandsList(response.data.carBrandsList);
      } catch (error) {
        console.log(error);
      }
      setBrandsLoading(false);
    };

    if (brandsList.length === 0) {
      getBrands();
    }
  }, [brandsList]);

  useEffect(() => {
    if (!brandsList.length) return;
    if (!selectedCar?.brand?.brandName) return;
    if (selectedCar?.brand?.id) return;

    const matchedBrand = brandsList.find(
      ({ brandName }) => brandName === selectedCar.brand.brandName
    );
    if (!matchedBrand) return;

    setSelectedCar((prevState) => ({
      ...prevState,
      brand: matchedBrand,
    }));
  }, [
    brandsList,
    selectedCar?.brand?.brandName,
    selectedCar?.brand?.id,
    setSelectedCar,
  ]);

  useEffect(() => {
    const getModels = async () => {
      setModelsLoading(true);
      try {
        const response = await getAllCarModelsInInventoryGivenCarBrandId(
          selectedCar.brand.id
        );
        setModelsList(response.data.carModelList);
      } catch (error) {
        console.log(error);
      }
      setModelsLoading(false);
    };

    if (selectedCar?.brand?.id) {
      getModels();
    }
  }, [selectedCar?.brand?.id]);

  useEffect(() => {
    if (!modelsList.length) return;
    if (!selectedCar?.model?.modelName) return;
    if (selectedCar?.model?.id) return;

    const matchedModel = modelsList.find(
      ({ modelName }) => modelName === selectedCar.model.modelName
    );
    if (!matchedModel) return;

    setSelectedCar((prevState) => ({
      ...prevState,
      model: matchedModel,
    }));
  }, [
    modelsList,
    selectedCar?.model?.modelName,
    selectedCar?.model?.id,
    setSelectedCar,
  ]);

  useEffect(() => {
    const getYears = async () => {
      setYearssLoading(true);
      try {
        const response = await getAllCarsInInventoryGivenCarModelId(
          selectedCar.model.id
        );
        setYearsList(response.data.carList);
      } catch (error) {
        console.log(error);
      }
      setYearssLoading(false);
    };

    if (selectedCar?.model?.id) {
      getYears();
    }
  }, [selectedCar?.model?.id]);

  useEffect(() => {
    if (!yearsList.length) return;
    if (!selectedCar?.year?.startYear || !selectedCar?.year?.endYear) return;
    if (selectedCar?.year?.id && selectedCar?.carDetails?.id) return;

    const matchedCar = yearsList.find(
      ({ startYear, endYear, id }) =>
        startYear === selectedCar.year.startYear &&
        endYear === selectedCar.year.endYear &&
        (!selectedCar?.carDetails?.id || id === selectedCar.carDetails.id)
    );
    if (!matchedCar) return;

    setSelectedCar((prevState) => ({
      ...prevState,
      year: matchedCar,
      carDetails: matchedCar,
    }));
  }, [
    yearsList,
    selectedCar?.year?.startYear,
    selectedCar?.year?.endYear,
    selectedCar?.year?.id,
    selectedCar?.carDetails?.id,
    setSelectedCar,
  ]);

  const getCarYearInitialValue = () => {
    if (selectedCar?.year?.startYear) {
      return `${selectedCar.year.startYear}-${selectedCar.year.endYear}`;
    } else {
      return "";
    }
  };

  const getTransmissionInitialValue = () => {
    if (selectedCar?.carDetails?.transmission) {
      return `${selectedCar.carDetails.transmission}-${selectedCar.carDetails.cc}`;
    } else {
      return "";
    }
  };

  let content;
  if (brandsLoading) {
    content = (
      <div className="flex mb-8 justify-content-center">
        <Ripple className="border-dark-blue" />
      </div>
    );
  } else if (brandsList.length !== 0) {
    content = (
      <section dir="rtl" className="my-4 grid items-center gap-4 grid-cols-2">
        <div>
          <label> ماركة السيارة </label>

          <Select
            placeholder="ماركة السيارة"
            options={brandsList}
            optionLabelProp="brandName"
            onSelect={carBrandSelectedHandler}
            initialValue={selectedCar?.brand?.brandName}
          />
        </div>

        <div>
          <label> موديل السيارة </label>

          <Select
            placeholder="موديل السيارة"
            options={modelsList}
            optionLabelProp="modelName"
            onSelect={carModelSelectedHandler}
            initialValue={selectedCar?.model?.modelName}
            isLoading={modelsLoading}
          />
        </div>

        <div>
          <label> سنة السيارة </label>
          <Select
            placeholder="سنة السيارة"
            options={yearsList}
            optionLabelProp="year"
            onSelect={carYearSelectedHandler}
            initialValue={getCarYearInitialValue}
            isLoading={yearsLoading}
          />
        </div>

        <div>
          <label> الفتيس </label>
          <Select
            placeholder="الفتيس"
            options={getCarDetails().options}
            optionLabelProp="transmission"
            onSelect={carDetailsSelectedHandler}
            initialValue={getTransmissionInitialValue}
          />
        </div>
      </section>
    );
  }
  return content;
};

export default CarSelection;
